import { Component, Vue } from 'vue-facing-decorator';
import FullScreenLoading from '@/components/common/FullScreenLoading.vue';
import { getPortalStore } from '@/stores/portal';
import { getBackgroundThemeUrl } from '@/helpers/staticAssets';

@Component({
  components: {
    FullScreenLoading,
  },
})
export default class App extends Vue {
  get backgroundThemeStyle() {
    const theme = getPortalStore().backgroundTheme;
    const url = getBackgroundThemeUrl(theme);
    return {
      '--background-theme': url ? `url('${url}')` : undefined,
    };
  }
}
